import { FilteredSection } from "@syadem/sad-js";
import { useEffect, useState } from "react";
import { DomainHealthRecord } from "../../domain/healthRecord";
import { useSad } from "./useSadApi";

export function useProfilQuestionnaire(healthRecord: DomainHealthRecord | undefined): {
  isLoading: boolean;
  questionnaireSections?: FilteredSection[];
  error?: Response | Error;
} {
  const api = useSad();
  const [questionnaireSections, setQuestionnaireSections] = useState<FilteredSection[] | undefined>(undefined);
  const [error, setError] = useState<Response | Error | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (api) {
        try {
          if (healthRecord) {
            const questionnaireSections: FilteredSection[] = await api.profilQuestionnaire({
              patient: {
                birthdate: healthRecord.birthDate,
                gender: healthRecord.gender == "M" ? "m" : "f",
              },
              requested_by_professional: true,
            });
            setQuestionnaireSections(questionnaireSections);
          }
        } catch (error) {
          if (error instanceof Response || error instanceof Error) {
            setError(error);
          } else {
            throw error;
          }
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [api, healthRecord]);

  return { isLoading, questionnaireSections, error };
}
